import { ChevronLeft, Dots } from "@/components/icons/outline"
import { useNavigate } from "react-router-dom"
import MobileNav from "@/components/partials/mobile-nav"
import { useState } from "react"

export default function Topbar({ title, showBackButton }) {
    // Hooks
    const [isShowMobileNav, setIsShowMobileNav] = useState(false)
    const navigate = useNavigate()

    return (
        <>
            <div className="flex items-center justify-center w-full px-6 py-4">
                <button onClick={() => navigate(-1)} className={`${showBackButton ? '' : 'opacity-0'} p-1 bg-white border rounded-full`}>
                    <ChevronLeft className="w-4 h-4" strokeWidth={2} />
                </button>
                <span className="flex-grow font-semibold text-center">{title}</span>
                <button onClick={() => setIsShowMobileNav(true)} className="p-1 bg-white border rounded-full opacity-100 md:opacity-0">
                    <Dots className="w-4 h-4" strokeWidth={2} />
                </button>
            </div>
            <MobileNav show={isShowMobileNav} onClose={() => setIsShowMobileNav(false)} />
        </>
    )
}